export type BaseDict = {
    MyPulseBets: string
    PlaceBet: string,
    PleaseLoginToPlaceBet: string,
    PulseBetInterval: string,
    TimeIsSeconds: string,
    ErrorMessage: string,
    StartsLabel: string,
    GoLabel: string,
    GermanTaxesMessage: string,
    BetWasAccepted: string,
    TicketLabel: string,
    GoToMyPulseBets: string,
    Suspended: string,
    Sec: string
}

export const BaseDict: BaseDict = {
    MyPulseBets: "My Pulse Bets",
    PlaceBet: "Place Pulse Bet",
    PleaseLoginToPlaceBet:"LOGIN TO BET",
    PulseBetInterval: "1 min Pulse",
    TimeIsSeconds: "Sec",
    ErrorMessage: "Error message",
    StartsLabel: "Starts In",
    GoLabel: "Go",
    GermanTaxesMessage: "In accordance with German tax law, {0} % tax will be deducted your total return.",
    BetWasAccepted: "Your bet was accepted",
    TicketLabel: "Ticket",
    GoToMyPulseBets: "Go to my pulse bets",
    Suspended: "Suspended",
    Sec: "Sec"
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./blocks/PulseBetMarkets/dict/dict.ts